import { Color, COLOR_HEX, COLOR_LABELS } from '@otrio/engine';

interface WinScreenProps {
  winner: Color;
  winnerName: string;
  onPlayAgain: () => void;
}

export function WinScreen({ winner, winnerName, onPlayAgain }: WinScreenProps) {
  const hex = COLOR_HEX[winner];

  return (
    <div className="win-banner" style={{ borderTopColor: hex }}>
      <svg className="win-banner-rings" width={48} height={48} viewBox="0 0 48 48">
        <circle cx={24} cy={24} r={20} fill="none" stroke={hex} strokeWidth={6} />
        <circle cx={24} cy={24} r={13} fill="none" stroke={hex} strokeWidth={5} opacity={0.75} />
        <circle cx={24} cy={24} r={5.5} fill="none" stroke={hex} strokeWidth={4} opacity={0.5} />
      </svg>
      <div className="win-banner-text">
        <span className="win-banner-headline" style={{ color: hex }}>OTRIO!</span>
        <span className="win-banner-sub">
          <strong>{winnerName}</strong> wins
          <span className="win-banner-color" style={{ color: hex }}> · {COLOR_LABELS[winner]}</span>
        </span>
      </div>
      <button className="win-banner-btn" style={{ borderColor: hex, color: hex }} onClick={onPlayAgain}>
        Play Again
      </button>
    </div>
  );
}
